import { render, staticRenderFns } from "./ContentPane.vue?vue&type=template&id=0d4d3fc1&scoped=true&"
import script from "./ContentPane.vue?vue&type=script&lang=ts&"
export * from "./ContentPane.vue?vue&type=script&lang=ts&"
import style0 from "./ContentPane.vue?vue&type=style&index=0&id=0d4d3fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4d3fc1",
  null
  
)

export default component.exports